import React from 'react';
import styles from './linkPolicyComp.module.scss';
import { ROUTER_GROUPS } from '@/core/constants/routes';
import { useRouter } from 'next/navigation';
import Image from 'next/image';
import { useDashboard } from '@/contexts/dashboard/dashboard.context';
import { useGtm } from '@/contexts/analytics/analytics.context';
import { BodyS } from '@/design-system/text/bodyS/bodyS';
import { Label } from '@/design-system/text/label/label';
import { PrimaryButton } from '@/design-system/buttons/primary-button/primary-button';

const LinkPolicyComp = () => {
  const { dashboardLabels } = useDashboard();
  const { policyDetailsCms } = dashboardLabels;
  const router = useRouter();
  const gtmMdule = useGtm();

  return (
    <>
      <div className={styles['insr-mb-img-title']}>
        <div className={styles['insr-mb-txt-con']}>
          <div className={styles['insr-mb-txt']}>
            <Label text={policyDetailsCms.linkPolicy.title} />
            <div className={styles['insr-mb-subtitle']}>
              <BodyS
                text={policyDetailsCms.linkPolicy.subtitle}
                className={styles['insr-policy-subtitle']}
              />
            </div>
          </div>
          <div className={styles['insr-mb-btn']}>
            <PrimaryButton
              id="link-policy-primarys-button-desktop"
              size="small"
              width="fit"
              variant="midnight"
              clevertapEventName={
                policyDetailsCms.linkPolicy.buttonTextClevertapEvent?.name
              }
              clevertapEventPayload={
                policyDetailsCms.linkPolicy.buttonTextClevertapEvent?.payload
              }
              onClick={() => {
                router.push(ROUTER_GROUPS.policy.actions.manualLinking());
              }}
              text={policyDetailsCms.linkPolicy.buttonText}
            />
          </div>
        </div>
        <Image
          src={policyDetailsCms.linkPolicy.img}
          alt={policyDetailsCms.title}
          width={170}
          height={156}
          className={styles['insr-mb-img']}
        />
      </div>
      <div className={styles['insr-img-title']}>
        <Image
          src={policyDetailsCms.linkPolicy.img}
          alt={policyDetailsCms.title}
          width={52}
          height={48}
        />
        <div className={styles['insr-title-btn-con']}>
          <div className={styles['insr-policy-title']}>
            <Label text={policyDetailsCms.linkPolicy.title} />
            <BodyS
              text={policyDetailsCms.linkPolicy.subtitle}
              className={styles['insr-policy-subtitle']}
            />
          </div>
          <PrimaryButton
            id="link-policy-primarys-button-mobile"
            size="small"
            width="fit"
            variant="midnight"
            clevertapEventName={
              policyDetailsCms.linkPolicy.buttonTextClevertapEvent?.name
            }
            clevertapEventPayload={
              policyDetailsCms.linkPolicy.buttonTextClevertapEvent?.payload
            }
            onClick={() => {
              router.push(ROUTER_GROUPS.policy.actions.manualLinking());
              gtmMdule.dashboard().sendSelectPromotion({
                id: 'policy details',
                name: policyDetailsCms.linkPolicy.buttonText,
              });
            }}
            text={policyDetailsCms.linkPolicy.buttonText}
          />
        </div>
      </div>
    </>
  );
};

export default LinkPolicyComp;
